export default __webpack_public_path__ + "static/media/printerKnife.8b911811.png";